// extracted by mini-css-extract-plugin
export default {"item":"ProductItem_item__BUURx","price":"ProductItem_price__TI3yA","actions":"ProductItem_actions__NxX5a"};